import { CSSProperties } from "react";
import { MessageBar, MessageBarType } from "@fluentui/react";
import { Spinner, SpinnerSize } from "@fluentui/react";
import hljs from "highlight.js/lib/core";
import jsonStyle from "highlight.js/lib/languages/json";

hljs.registerLanguage("json", jsonStyle);

type JsonViewerProps = {
  json?: Record<any, any>;
  path: string;
  message?: string;
  isLoading: boolean;
};

export const JsonViewer = (props: JsonViewerProps) => {
  const { json, message, path, isLoading } = props;
  const content = json || null;
  const markup = content
    ? hljs.highlight(JSON.stringify(content, null, 2), {
        language: "json",
      }).value
    : "";

  const renderedContent = (
    <div className="input_area" style={blockStyle}>
      <pre dangerouslySetInnerHTML={{ __html: markup }}></pre>
    </div>
  );

  return (
    <>
      <h2>JSON API Viewer</h2>
      <pre>{path}</pre>
      {isLoading && (
        <Spinner size={SpinnerSize.large} style={{ alignItems: "start" }} />
      )}
      {message && (
        <MessageBar messageBarType={MessageBarType.error}>{message}</MessageBar>
      )}
      {markup && renderedContent}
    </>
  );
};

const blockStyle: CSSProperties = {
  marginBottom: "20px",
};
